<rt-dialog-header [heading]="'app.pricing.job_slots_dialog.heading' | translate" />

<rt-dialog-body layout-vertical>
  <rt-heading>{{ 'app.pricing.job_slots_dialog.subheading' | translate }}</rt-heading>
  {{ 'app.pricing.job_slots_count' | translate: { count: slots } }}
  <rt-divider margin-tb />

  @if (model) {
    <rt-heading>{{ 'app.pricing.job_slots_dialog.slots_picker_heading' | translate }}</rt-heading>
    <rt-job-slots-picker
      margin-bottom
      class="slots-picker"
      [product]="activeProduct"
      [value]="selectedSlots!"
      [ownedSlots]="ownedSlots"
      [isManualSubscription]="!!model.subscription?.manual"
      (slotsChange)="slotsChanged($event)"
    />

    @if (!!selectedSlots && ownedSlots !== selectedSlots && !consentRequired) {
      <rt-heading>
        {{ 'app.pricing.job_slots_dialog.new_subscription_cost_header' | translate }}
      </rt-heading>
      <rt-subscription-cost
        [product]="activeProduct"
        [slots]="selectedSlots"
        [interval]="paymentInterval"
        [addons]="addons"
      />

      @if (slotsMinLimit.exceeded) {
        <rt-job-slots-limit-message [numberOfJobsToArchive]="slotsMinLimit.jobs" margin-top />
      }
    }
    @if (
      model.subscription?.tier === BillingPlanTier.Launch && ownedSlots === 5 && selectedSlots! > 5
    ) {
      <rt-infobox [isDismissible]="false" iconName="warning" type="warning" margin-top-small>
        {{ 'app.pricing.launch_5' | translate }}
      </rt-infobox>
    }

    @if (model.subscription?.manual === false) {
      <rt-infobox [isDismissible]="false" iconName="warning" type="warning" margin-top-small>
        <span [innerHTML]="legacyPlansInfoboxContent"></span>
      </rt-infobox>
    }

    @if (ownedSlots !== selectedSlots && consentRequired) {
      @if (!billingEstimatePending && billingEstimate) {
        <rt-heading>
          {{ 'app.pricing.job_slots_dialog.additional_subscription_fee' | translate }}
        </rt-heading>
        <div layout>
          {{ totalCostSelected - model.subscription!.amount / 100 | currency: model.currency }}
          <rt-divider variant="dot" />
          {{ paymentIntervalText }}
        </div>
        <rt-heading margin-top>
          {{ 'app.pricing.job_slots_dialog.total_fees_for_update' | translate }}
        </rt-heading>
        <div>
          {{
            'app.pricing.job_slots_dialog.for_remaining_period'
              | translate
                : {
                    price: (billingEstimate.amountDue || 0) / 100 | currency: model.currency,
                    date:
                      billingEstimate.nextBillingAt
                      | rtDateFormatTimezone: 'Europe/Amsterdam' : 'DD MMMM YYYY',
                  }
          }}
        </div>
        <rt-divider margin-tb />
        <div class="text-small-x">
          <span
            [innerHTML]="'app.pricing.job_slots_dialog.terms_visible' | translate"
            class="terms-visible"
          ></span>
          @if (!showFullTerms) {
            <span (click)="onShowMore()" class="show-more">{{
              'app.common.show_more' | translate
            }}</span>
          }
          @if (showFullTerms) {
            <span>
              {{ 'app.pricing.job_slots_dialog.terms_hidden_1' | translate }}
            </span>
          }
        </div>
        @if (showFullTerms) {
          <div margin-top class="text-small-x">
            {{ 'app.pricing.job_slots_dialog.terms_hidden_2' | translate }}
          </div>
        }
        <rt-checkbox [formControl]="consentControl" margin-top-small>
          {{ 'app.pricing.job_slots_dialog.checkbox_consent_label' | translate }}
        </rt-checkbox>
      } @else {
        <rt-spinner />
      }
    }

    @if (errorMessage) {
      <rt-message variant="context-error" margin-top>{{ errorMessage }}</rt-message>
    }
  }
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button (click)="close()" variant="plain" margin-right-small>
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button
    [loading]="loading"
    [disabled]="
      !model ||
      loading ||
      selectedSlots === slots ||
      slotsMinLimit?.exceeded! ||
      (consentRequired && !consentControl.value)
    "
    (click)="changeSlots(selectedSlots!, slots!)"
    variant="primary"
    >{{ 'app.pricing.job_slots_dialog.update_slots' | translate }}</rt-button
  >
</rt-dialog-footer>
